export default "__VITE_ASSET__BaDxqRQw__"